export default {
  PLUGIN_SERVER_URL: 'http://localhost:3001',
};
